import { Container, StepButtonsGroup, Form } from '../components';
import { FormContextProvider } from '../Context';
import * as S from './styles';

const CreateEvent = () => {
  return (
    <FormContextProvider isCreate>
      <S.Wrapper>
        <StepButtonsGroup />
        <Container>
          <Form isCreate />
        </Container>
      </S.Wrapper>
    </FormContextProvider>
  );
};
export default CreateEvent;
